import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from 'moment';
import ContractCard from './ContractCard';
import { contractTypes } from '../../constants';
import styles from './styles';
function Summary(props) {
  let loggedInUser = null;
  if (localStorage.getItem('selectedAccount')) {
    const adddata = localStorage?.selectedAccount;
    loggedInUser = JSON.parse(adddata);
  }
  const isOffPlanDeveloper = loggedInUser?.isDeveloper || false;

  const { classes, contract, selectable, selected, setSelected, type, hideContractDetailsBtn } = props;

  const onItemClick = useCallback(
    data => {
      if (selected?.contractId === data.contractId) {
        setSelected(null);
        return;
      }
      setSelected(data);
    },
    [selected],
  );

  const getPathName = contractType => {
    switch (contractType) {
      case contractTypes.offPlan:
        return `/app/contract/offPlan/${contract?.contractId}`;
      case contractTypes.lease:
        return `/app/contract/lease/${contract?.contractId}`;
      case contractTypes.pma:
        return `/app/contract/pma/${contract?.contractId}`;
      case contractTypes.musataha:
        return `/app/contract/musataha/${contract?.contractSource?.toLowerCase() || 'assets'}/${contract?.contractId}`;
      case contractTypes.mortgage:
        return `/app/contract/mortgage/${contract?.contractId}`;
      case contractTypes.poa:
        return `/app/contract/poa/${contract?.contractId}`;
      default:
        return '';
    }
  };
  const contractSource = contract?.contractSource;
  const LABELS_MAP = {
    [contractTypes.lease]: [
      { label: 'contract_value', value: contract?.amount, isAmount: true },
      { label: 'start_date', value: contract?.startDate, smDownHidden: true },
      { label: 'end_date', value: contract?.endDate, smDownHidden: true },
      {
        label: 'unit_no',
        value: contract?.unitRegNumber,
      },
    ],
    [contractTypes.pma]: [
      {
        label: 'contract_value',
        value: contract?.amountType === 'AED' ? contract?.amount : contract?.amount + ' %',
        isAmount: contract?.amountType === 'AED',
      },
      { label: 'start_date', value: contract?.startDate, smDownHidden: true },
      { label: 'end_date', value: contract?.endDate, smDownHidden: true },
      {
        label: 'unit_hash',
        value: contract?.unitRegNumber,
        smDownHidden: true,
      },
      // {
      //   label: 'pma_classification',
      //   value:
      //     contract?.pmaClassification === 'Main'
      //       ? 'main_pma'
      //       : contract?.pmaClassification === 'Sub'
      //       ? 'sub_pma'
      //       : null,
      //   isLokalisedValue: true,
      // },
    ],
    [contractTypes.offPlan]: [
      { label: 'project_name', value: contract?.projectName },
      ...(contract?.propertyType === 4
        ? [
            { label: 'building_name_number', value: contract?.buildingName },
            {
              label: 'unit_hash',
              value: contract?.unitRegNumber || contract?.unitNumber,
            },
          ]
        : []),
      ...(contract?.propertyType === 1
        ? [
            { label: 'plot_address', value: contract?.plotAddress },
            { label: 'plot_number', value: contract?.plotNumber },
          ]
        : []),
      {
        label: 'date_of_sale',
        value: moment(contract?.dateOfSale).format('DD/MM/YYYY'),
        smDownHidden: true,
      },
      { label: 'sale_price', value: contract?.salePrice, isAmount: true },
      ...(contract?.contractEndDate
        ? [
            {
              label: 'contract_end_date',
              value: moment(contract?.contractEndDate).format('DD/MM/YYYY'),
              smDownHidden: true,
            },
          ]
        : []),
    ],

    [contractTypes.musataha]: [
      {
        label: contractSource === 'Individual' ? 'contract_amount' : 'annual_rent_amount',
        value: contractSource === 'Individual' ? contract?.contractAmount : contract?.annualRent,
        isAmount: true,
      },
      { label: 'plot_number', value: contract?.plotNumber },
      { label: 'start_date', value: contract?.startDate, smDownHidden: true },
      { label: 'end_date', value: contract?.endDate, smDownHidden: true },
    ],
    [contractTypes.mortgage]: [
      { label: 'contract_value', value: contract?.amount, isAmount: true },
      {
        label: 'start_date',
        value: contract?.startDate ? moment(contract?.startDate).format('DD/MM/YYYY') : '-',
        smDownHidden: true,
      },
      {
        label: 'end_date',
        value: contract?.endDate ? moment(contract?.endDate).format('DD/MM/YYYY') : '-',
        smDownHidden: true,
      },
      { label: 'mortgage_type', value: contract?.mortgageType },
      {
        label: 'mortgage_bank',
        value: contract?.mortgageBank,
        smDownHidden: true,
      },
    ],
    [contractTypes.poa]: [
      { label: 'contract_type', value: contract?.contractType },
      { label: 'start_date', value: contract?.startDate },
      { label: 'end_date', value: contract?.endDate },
    ],
  };

  const ENTITIES_MAP = {
    [contractTypes.lease]: [
      {
        label: 'tenant_name',
        value: contract?.tenantName,
      },
    ],
    [contractTypes.pma]: [
      { label: 'first_party', value: contract?.firstPartyName },
      { label: 'second_party', value: contract?.secondPartyName },
    ],
    [contractTypes.offPlan]: [
      {
        label: isOffPlanDeveloper ? 'buyer_name' : 'developer_name',
        value: isOffPlanDeveloper ? contract?.buyerName : contract?.developerName,
      },
    ],
    [contractTypes.musataha]: [{ label: 'musateh_name', value: contract?.name }],
    [contractTypes.mortgage]: [],
    [contractTypes.poa]: [{ label: 'second_party', value: contract?.secondPartyName }],
  };

  const FOOTER_MAP = {
    [contractTypes.lease]: [
      {
        label: 'date',
        value: contract?.startDate ? moment(contract?.startDate).format('DD/MM/YYYY') : '-',
      },
      {
        label: 'to',
        value: contract?.endDate ? moment(contract?.endDate).format('DD/MM/YYYY') : '-',
      },
    ],
    [contractTypes.musataha]: [
      {
        label: 'date',
        value: contract?.startDate ? moment(contract?.startDate).format('DD/MM/YYYY') : '-',
      },
      {
        label: 'to',
        value: contract?.endDate ? moment(contract?.endDate).format('DD/MM/YYYY') : '-',
      },
    ],
    [contractTypes.offPlan]: [
      {
        label: 'date_of_sale',
        value: contract?.startDate ? moment(contract?.startDate).format('DD/MM/YYYY') : '-',
      },
    ],
    [contractTypes.pma]: [
      {
        label: 'date',
        value: contract?.startDate ? moment(contract?.startDate).format('DD/MM/YYYY') : '-',
      },
      {
        label: 'to',
        value: contract?.endDate ? moment(contract?.endDate).format('DD/MM/YYYY') : '-',
      },
    ],
    [contractTypes.mortgage]: [],
    [contractTypes.poa]: [],
  };

  return (
    <div className={classes.listItemContainer}>
      <ListItem
        className={classes.listItem}
        dense
        button
        {...(selectable
          ? { onClick: () => onItemClick(contract) }
          : {
              component: RouterLink,
              to: {
                pathname: getPathName(type),
                state: { contract },
              },
            })}
      >
        <ListItemText
          id={contract?.contractId}
          primary={
            <ContractCard
              hideContractDetailsBtn={hideContractDetailsBtn}
              contract={contract}
              type={type}
              labels={LABELS_MAP[type]}
              entities={ENTITIES_MAP[type]}
              footer={FOOTER_MAP[type]}
              selected={selected}
              selectable={selectable}
            />
          }
        />
      </ListItem>
    </div>
  );
}

Summary.propTypes = {
  classes: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  selectable: PropTypes.bool.isRequired,
  selected: PropTypes.object,
  setSelected: PropTypes.func.isRequired,
  hideContractDetailsBtn: PropTypes.bool,
};

Summary.defaultProps = {
  selected: null,
  hideContractDetailsBtn: false,
};

export default withStyles(styles)(memo(Summary));
